{
    "RestNoContentError": "Reactie-inhoud werd verwacht, maar er werd geen gegeven",
    "RestJsonProcessing": "Verwerken.",
    "NAME": "LanguageErrors",
    "UnhandlableError": "Er is een onhanteerbare fout opgetreden bij de Akixi-service.",
    "UnknownError": "Er was een onbekende serverfout",
    "InvalidCmeId": "Ongeldig CME-ID"
}